<template>
  <v-otp-input
    v-if="joinMode === 'pin'"
    class="otp-input"
    :error="sessionErrorMsg"
    v-model="pin"
    :length="6"
    autofocus
    :disabled="isJoining"
    pattern="numeric"
    @finish="handlePinFinish"
    density="compact"
  />
  <v-text-field
    v-if="joinMode === 'key'"
    :model-value="session.conference"
    class="code-value"
    append-inner-icon="content_copy"
    variant="outlined"
    readonly
    hide-details
    bg-color="#fafafa"
    @click:append-inner="copy"
  >
    <template v-slot:prepend-inner>
      <v-icon ref="qrIcon" icon="qr_code_2" @click="qrOpened = true" />
    </template>
  </v-text-field>
  <v-menu
    v-model="qrOpened"
    location="top center"
    :offset="[10, 0]"
    eager
    scrim
    :close-on-content-click="false"
    :target="qrIcon"
  >
    <v-sheet class="qr-popover" :style="{'--qr-arrow-x': '50%'}">
      <canvas ref="canvas" :width="200" :height="200"></canvas>
    </v-sheet>
  </v-menu>
</template>
<script setup>
import {onMounted, ref} from 'vue'
import {useSessionStore} from '@/stores'
import {usePreCall} from '@/stores/preCall'
import {storeToRefs} from 'pinia'
import qrCode from 'qrcode'
import {useDisplay} from 'vuetify'

const preCall = usePreCall()
const {pin, joinMode, isJoining, sessionErrorMsg, isJoinButtonDisabled} = storeToRefs(preCall)
const session = useSessionStore()
const canvas = ref(null)
const qrIcon = ref(null)
const qrOpened = ref(false)
const handlePinFinish = async () => {
  await preCall.joinSession()
}
onMounted(() => {
  if (joinMode.value === 'key') {
    qrCode.toCanvas(canvas.value, window.location.href, {width: 200, margin: 1})
  }
})
const copy = () => navigator.clipboard.writeText(session.conference)
</script>
<style>
.otp-input .v-field--focused:not(.v-field--error) .v-field__outline {
  color: rgb(var(--v-theme-primary));
  --v-field-border-opacity: 1;
}
</style>
<style lang="scss" scoped>
$qr-arrow-size: 12px;
.code-value {
  :deep(input) {
    text-align: center;
    color: $font-gray-1;
  }
}
.qr-popover {
  padding: 0.5em;
  display: flex;
  justify-content: center;
  align-items: center;
  &::after {
    content: '';
    position: absolute;
    left: var(--qr-arrow-x, 50%);
    bottom: -($qr-arrow-size * 0.5);
    width: $qr-arrow-size;
    height: $qr-arrow-size;

    background: $background-neutral-0;
    transform: translateX(-50%) rotate(45deg);
    box-shadow: 3px 3px 4px rgba(0, 0, 0, 0.1);
  }
}
</style>
